import { fromEvent, Observable } from 'rxjs';

export enum ConnectionStatusEnum {
  Online = 'ONLINE',
  Offline = 'OFFLINE'
}

export class NetworkConnection {
  public static status: ConnectionStatusEnum = ConnectionStatusEnum.Online;
  public static online$: Observable<Event>;
  public static offline$: Observable<Event>;

  public static init(): void {
    NetworkConnection.online$ = fromEvent(window, 'online');
    NetworkConnection.offline$ = fromEvent(window, 'offline');
  }

  constructor() {
    NetworkConnection.init();
  }
}
